module.exports = __webpack_public_path__ + "fonts/Fofer.56df969.otf";